export default "__VITE_ASSET__BkpZg2sQ__"